import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
}

export default function OutdentIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "27"}
      height={height || "30"}
      viewBox="0 0 27 30"
    >
      <rect
        id="Rectangle_1941"
        data-name="Rectangle 1941"
        width="27"
        height="30"
        rx="5"
        fill="#f9f9f9"
      />
      <path
        id="Union_25"
        data-name="Union 25"
        d="M.5,14a.5.5,0,0,1-.5-.5v-.75a.5.5,0,0,1,.5-.5h14a.5.5,0,0,1,.5.5v.75a.5.5,0,0,1-.5.5Zm2.253-4L.128,7.371a.438.438,0,0,1,0-.618L2.753,4.127a.438.438,0,0,1,.747.31v5.25a.437.437,0,0,1-.441.438A.427.427,0,0,1,2.753,10ZM5.5,9.936a.5.5,0,0,1-.5-.5v-.75a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v.75a.5.5,0,0,1-.5.5Zm0-4.064a.5.5,0,0,1-.5-.5V4.622a.5.5,0,0,1,.5-.5h9a.5.5,0,0,1,.5.5v.751a.5.5,0,0,1-.5.5ZM.5,1.75a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0h14a.5.5,0,0,1,.5.5V1.25a.5.5,0,0,1-.5.5Z"
        transform="translate(6 8)"
        fill="#707070"
      />
    </svg>
  );
}
